// Vendor imports
const _ = require('lodash')
const { createSelector } = require('reselect')
// ShareModal V1 container imports
const shareModalSelectors = require('client-v2/common/containers/share-modal/selectors')

const isVisible = createSelector(
  [
    state => state.user,
    shareModalSelectors.containerState
  ],
  (user, s) => Boolean(
    _.get(s, 'feedItem') &&
    _.get(s, 'anchorId') &&
    user.hasRollout('web_share_modal_v2')
  )
)

const anchorId = createSelector(
  shareModalSelectors.containerState,
  s => _.get(s, 'anchorId')
)

const contentId = createSelector(
  shareModalSelectors.containerState,
  s => (
    _.get(s, 'feedItem.article.url_id') ||
    _.get(s, 'feedItem.collection.id') ||
    _.get(s, 'feedItem.user.id')
  )
)

const isSocialButtonsVisible = createSelector(
  shareModalSelectors.friends,
  friends => Boolean(
    friends &&
    friends.filter(friend => friend.isSelected).size === 0
  )
)

module.exports = {
  anchorId,
  contentId,
  isVisible,
  isSocialButtonsVisible
}
